module.exports = __webpack_public_path__ + "1ee4aada.svg";